module.exports = __webpack_public_path__ + "img/17.e1ac4f06.jpg";